import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import LoggerService from "../../../state/logger/LoggerService"
import RainforestButton from "./RainforestButton"
import { RF_COLOR_CODES, RF_METHOD_TYPES } from "./constants"

type RFPayInEventDetail = {
    data: {
        refusal_desc: string
        payment_method_id: string
        payin_id: string
    }
    errors: unknown | null
    status: string
}

export type RFPayInEvent = React.SyntheticEvent & {
    detail: RFPayInEventDetail[]
}

type OwnProps = {
    sessionKey: string
    paymentMethodConfigID: string
    payinConfigID: string
    allowedMethods: string
    refresh: () => void
    onSubmit?: (event) => void
    handleClickEvent?: () => void
    threedsAttemptClosed?: () => void
    threedsAttemptOpened?: () => void
    handleErrorEvent?: (event: RFPayInEvent) => void
    buttonColor: string
    amount?: number
    currency?: string
    method: RF_METHOD_TYPES
}

const RainforestPayment = (props: OwnProps) => {

    useEffect(() => {
        const component = document.querySelector("rainforest-payment")
        if (component) {
            component.addEventListener("approved", handleApproved)
            component.addEventListener("attempted", handleClickEvent)
            component.addEventListener("declined", handleErrorEvent)
            component.addEventListener("error", handleErrorEvent)
            component.addEventListener("valid", handleValid)
            component.addEventListener("invalid", handleInvalid)
            component.addEventListener("threeds-challenge-opened", handleThreedsAttemptOpened)
            component.addEventListener("threeds-challenge-closed", handleThreedsAttemptClosed)
        }

        return () => {
            if (component) {
                component.removeEventListener("approved", handleApproved)
                component.removeEventListener("attempted", handleClickEvent)
                component.removeEventListener("declined", handleErrorEvent)
                component.removeEventListener("error", handleErrorEvent)
                component.removeEventListener("valid", handleValid)
                component.removeEventListener("invalid", handleInvalid)
                component.removeEventListener("threeds-challenge-opened", handleThreedsAttemptOpened)
                component.removeEventListener("threeds-challenge-closed", handleThreedsAttemptClosed)
            }
        }
    })

    const [isDisabled, setIsDisabled] = useState<boolean>(true)


    const handleErrorEvent = (event) => {
        if (props.handleErrorEvent) {
            props.handleErrorEvent(event)
        }
    }

    const handleClickEvent = () => {
        const payload = {
            logMessage: "RF Payment Button Clicked Event",
            logBody: {
                payinConfigId: props.payinConfigID,
                amount: props.amount,
                method: props.method,
            }
        }

        LoggerService.LogRequest(payload)
        if (props.handleClickEvent) {
            props.handleClickEvent()
        }
    }

    const handleThreedsAttemptOpened = () => {
        const payload = {
            logMessage: "RF Threeds Attempt Opened",
            logBody: {
                payinConfigId: props.payinConfigID,
                amount: props.amount,
                method: props.method,
            }
        }

        LoggerService.LogRequest(payload)

        if (props.threedsAttemptOpened) {
            props.threedsAttemptOpened()
        }
    }

    const handleThreedsAttemptClosed = () => {
        const payload = {
            logMessage: "RF Threeds Attempt Closed",
            logBody: {
                payinConfigId: props.payinConfigID,
                amount: props.amount,
                method: props.method,
            }
        }

        LoggerService.LogRequest(payload)
        if (props.threedsAttemptClosed) {
            props.threedsAttemptClosed()
        }
    }

    const handleApproved = async (event) => {
        if (props.onSubmit) {
            props.onSubmit(event)
        }
    }

    const handleValid = () => {
        setIsDisabled(false)
    }

    const handleInvalid = () => {
        setIsDisabled(true)
    }

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            event.preventDefault()
        }
    }

    return (
        <>
            {
                props.method == RF_METHOD_TYPES.SAVE_CARD ?
                    /* @ts-ignore */
                    <rainforest-payment
                        key={props.payinConfigID || props.paymentMethodConfigID}
                        session-key={props.sessionKey}
                        payment-method-config-id={props.paymentMethodConfigID}
                        payin-config-id={props.payinConfigID}
                        allowed-methods={props.allowedMethods}
                    >
                        {/* @ts-ignore */}
                    </rainforest-payment> :
                    <>
                        <div onKeyDown={handleKeyPress}>
                            {/* @ts-ignore */}
                            <rainforest-payment
                                key={props.payinConfigID || props.paymentMethodConfigID}
                                session-key={props.sessionKey}
                                payment-method-config-id={props.paymentMethodConfigID}
                                payin-config-id={props.payinConfigID}
                                allowed-methods={props.allowedMethods}
                                hide-button
                            >
                                {/* @ts-ignore */}
                            </rainforest-payment>
                        </div>
                        <RainforestButton
                            key={"btn-" + (props.payinConfigID || props.paymentMethodConfigID)}
                            method={props.method}
                            amount={props.amount}
                            currency={props.currency}
                            payBtnColor={props.buttonColor || RF_COLOR_CODES.BLUE}
                            onClick={props.refresh}
                            disabled={isDisabled}
                            payinConfigId={props.payinConfigID}
                        />
                    </>
            }
        </>
    )
}

export default injectIntl(RainforestPayment)



// WEBPACK FOOTER //
// ./src/common/credit-card/rf-components/RainforestPayment.tsx